import React from 'react';
import PropTypes from 'prop-types';
import { Loc } from 'redux-react-i18n';
import { Link } from 'react-router-dom';
import Media from 'react-media';
import LazyLoad from 'react-lazyload';
import smoothscroll from 'smoothscroll-polyfill';
import Dotdotdot from 'react-dotdotdot';
import Loader from 'components/mediabay-ui/components/Loader';
import Button from 'components/mediabay-ui/components/Button';
import Title from 'components/mediabay-ui/components/Title';
import Carousel from 'components/mediabay-ui/components/Carousel';
import CarouselTitle from './common/CarouselTitle';
import CarouselContainer from './common/CarouselContainer';
import CarouselEmpty from './common/CarouselEmpty';

smoothscroll.polyfill();

class MediasCarousel extends React.Component {
  static propTypes = {
    currentLanguage: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    buttonContent: PropTypes.node.isRequired,
    titleRoute: PropTypes.string.isRequired,
    itemRoute: PropTypes.string.isRequired,
    getMedias: PropTypes.func.isRequired,
    mediasData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    landscapeCover: PropTypes.bool,
  }

  static defaultProps = {
    landscapeCover: false,
  }

  constructor(props) {
    super(props);

    this.state = {
      isMediasFetching: true,
      mediasData: this.props.mediasData,
    };
  }

  componentDidMount() {
    const { mediasData } = this.state;
    if (mediasData.data.length === 0) {
      return this.props.getMedias();
    }

    return null;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.mediasData) {
      if (
        prevState.mediasData.status === 200
        || prevState.mediasData.status !== nextProps.mediasData.status
      ) {
        return {
          isMediasFetching: false,
          mediasData: nextProps.mediasData,
        };
      }
    }

    return null;
  }

  render() {
    const { isMediasFetching, mediasData } = this.state;
    const { currentLanguage, landscapeCover } = this.props;

    let carouselContent = null;

    if (isMediasFetching) {
      carouselContent = (
        <CarouselEmpty>
          <Loader />
        </CarouselEmpty>
      );
    } else if (isMediasFetching === false && mediasData.status !== 200) {
      carouselContent = (
        <CarouselEmpty>
          <Loc locKey="loadingError" />
        </CarouselEmpty>
      );
    } else if (mediasData.data.length === 0) {
      carouselContent = (
        <CarouselEmpty>
          <Loc locKey="noMediaData" />
        </CarouselEmpty>
      );
    } else {
      carouselContent = (
        <Carousel
          containerOffset={65}
          childWidth={200}
        >
          {
            mediasData.data.map(media => (
              <Link
                key={media.id}
                to={`/${this.props.itemRoute}/${media.id}`}
                style={{ cursor: 'pointer' }}
              >
                <LazyLoad
                  height={200}
                  debounce={50}
                >
                  <img
                    alt={media.title[currentLanguage]}
                    src={media.picture.replace(/.png|.jpg|.jpeg/, match => `.200${match}`)}
                    width={200}
                    height={landscapeCover ? 133 : 355}
                    style={{ objectFit: 'cover' }}
                  />
                </LazyLoad>

                <Dotdotdot clamp={2} useNativeClamp>
                  <Title>
                    {media.title[currentLanguage]}
                  </Title>
                </Dotdotdot>
              </Link>
            ))
          }
        </Carousel>
      );
    }
    return (
      <section ref={(mediaCarouselRef) => { this.mediaCarouselRef = mediaCarouselRef; }}>
        <CarouselTitle level={2}>
          <Link to={`/${this.props.titleRoute}`}>
            {this.props.title}
          </Link>
          <Media
            query="(min-device-width: 500px)"
            render={() => (
              <Link to={`/${this.props.titleRoute}`} style={{ marginRight: 25 }}>
                <Button>
                  {this.props.buttonContent}
                </Button>
              </Link>
            )}
          />
        </CarouselTitle>
        <CarouselContainer>
          {carouselContent}
        </CarouselContainer>
      </section>
    );
  }
}

export default MediasCarousel;
